import Vue from 'vue'
import App from './App.vue'
import Index from './components/Index'
import Thread from './components/Thread'
import VueRouter from 'vue-router'
import Buefy from 'buefy'
import Moment from 'moment'
import titleMixin from './util/title'
Vue.use(VueRouter)
Vue.use(Buefy)
Vue.mixin(titleMixin)

window.axios = require('axios')
Vue.prototype.$http = window.axios

const router = new VueRouter({
  mode: 'history',
  base: '/bbs/',
  routes: [
    //components require('./components/~')するとanonymous component error
    { path: '/', name: 'Index', component: Index },
    { path: '/page/:page', name: 'IndexPaged', component: Index },
    { path: '/thread/:num', name: 'Thread', component: Thread },
    { path: '*', name: 'Index0', component: Index },
  ]
})

new Vue({
  router,
  el: '#app',
  template: '<App/>',
  components: { App }
})

Vue.filter('moment', function (date) {
  return Moment(date).format('YYYY/MM/DD HH:mm')
})


// WEBPACK FOOTER //
// ./src/main.js